import React from 'react'

function EBikeIcon({ className }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      fill='currentColor'
      height='28px'
      width='28px'
      // className='text-inherit'
      stroke='blue'
      stroke-width='1.5'
      stroke-linecap='round'
      stroke-linejoin='round'
      id='Layer_1'
      // fill='none'
      viewBox='0 0 512 512'
      // xmlSpace='preserve'
    >
      <g>
        <g>
          <path d='M422.957,66.783h-85.158C330.042,28.725,296.313,0,256,0s-74.042,28.725-81.799,66.783H89.044    c-9.22,0-16.696,7.475-16.696,16.696s7.475,16.696,16.696,16.696h85.158c3.595,17.642,12.773,33.278,25.6,44.977    c-17.948,7.514-34.419,18.557-48.539,32.768c-28.16,28.34-43.668,65.953-43.668,105.907v120.546    c0,22.522,18.323,40.845,40.845,40.845h57.473v16.696C205.913,489.531,228.382,512,256,512c27.618,0,50.087-22.469,50.087-50.087    v-16.696h59.329c22.522,0,40.845-18.323,40.845-40.845V283.826c0-39.954-15.509-77.567-43.669-105.907    c-14.46-14.552-31.388-25.776-49.84-33.296c12.533-11.641,21.504-27.067,25.047-44.449h85.158c9.22,0,16.696-7.475,16.696-16.696    S432.177,66.783,422.957,66.783z M256,33.391c27.618,0,50.087,22.469,50.087,50.087c0,27.618-22.469,50.087-50.087,50.087    c-27.618,0-50.087-22.469-50.087-50.087C205.913,55.86,228.382,33.391,256,33.391z M272.696,461.913    c0,9.206-7.49,16.696-16.696,16.696s-16.696-7.49-16.696-16.696V395.13c0-9.206,7.49-16.696,16.696-16.696    s16.696,7.49,16.696,16.696V461.913z M372.87,283.826v120.546c0,4.109-3.344,7.454-7.454,7.454h-59.329V395.13    c0-27.618-22.469-50.087-50.087-50.087c-27.618,0-50.087,22.469-50.087,50.087v16.696H148.44c-4.11,0-7.454-3.344-7.454-7.454    V283.826c0-63.967,52.003-116.368,115.942-116.865C320.867,167.458,372.87,219.859,372.87,283.826z' />
        </g>
      </g>
    </svg>
  )
}

export default EBikeIcon
